module.exports = __webpack_public_path__ + "strawberry.jpg?fdd1332a9f86fe1fcc22e8f900bdf21b";